import { render, staticRenderFns } from "./MaterialDistribution-new.vue?vue&type=template&id=6d17e25e&scoped=true&"
import script from "./MaterialDistribution-new.vue?vue&type=script&lang=js&"
export * from "./MaterialDistribution-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d17e25e",
  null
  
)

export default component.exports